/* eslint-disable */

import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import PAGE_381 from "../pages/page_381/page_381";
import PAGE_382 from "../pages/page_382/page_382";
import PAGE_385 from "../pages/page_385/page_385";
import PAGE_486 from "../pages/page_486/page_486";
import PAGE_383 from "../pages/page_383/page_383";
import PAGE_387 from "../pages/page_387/page_387";
import PAGE_388 from "../pages/page_388/page_388";
import PAGE_380 from "../pages/page_380/page_380";
import PAGE_389 from "../pages/page_389/page_389";
import PAGE_390 from "../pages/page_390/page_390";
import PAGE_384 from "../pages/page_384/page_384";
import PAGE_391 from "../pages/page_391/page_391";
import PAGE_392 from "../pages/page_392/page_392";
import PAGE_485 from "../pages/page_485/page_485";
import PAGE_378 from "../pages/page_378/page_378";
import SSOFT_HEADER_912 from '../sections/SSoft_Header_912/SSoft_Header';
import SSOFT_FOOTER_913 from '../sections/SSoft_Footer_913/SSoft_Footer';

export default function Site() {
    let location = useLocation();
    let path_name = location.pathname;
    let path_name_without_last_slash = path_name.replace(/\/$/, '');
    if (path_name === '/') path_name_without_last_slash = '/';
    const urls_use_global_sections = [
        "/about",
        "/about",
        "/services",
        "/services",
        "/solutions/financial-management",
        "/solutions/manajemen-keuangan",
        "/solutions",
        "/solutions",
        "/help",
        "/bantuan",
        "/help/faq",
        "/bantuan/faq",
        "/help/contact",
        "/bantuan/kontak",
        "/solutions/enterprise-performance-management",
        "/solutions/manajemen-kinerja-perusahaan",
        "/help/privacy-policy",
        "/bantuan/kebijakan-privasi",
        "/solutions/enterprise-asset-management",
        "/solutions/manajemen-aset-perusahaan",
        "/solutions/expense-management",
        "/solutions/manajemen-biaya",
        "/blogs",
        "/blogs",
        "/blogs/detail",
        "/blogs/detail",
        "/",
    ];
    const urls_use_global_sections_and_has_params = [
        "/blogs/detail",
        "/blogs/detail",
    ];
    const is_use_global_sections = urls_use_global_sections.includes(path_name_without_last_slash);
    const use_global_sections_and_has_params = urls_use_global_sections_and_has_params.some(url => path_name_without_last_slash.startsWith(url));
    let header = null
    if (is_use_global_sections || use_global_sections_and_has_params) header = <SSOFT_HEADER_912/>
    let footer = null
    if (is_use_global_sections || use_global_sections_and_has_params) footer = <SSOFT_FOOTER_913/>
    return (
        <>
            {header}
            <Routes>
                <Route path={`/solutions`} exact element={<Navigate to={`/solutions/financial-management`} replace />}/>
                <Route path={`/solutions`} exact element={<Navigate to={`/solutions/financial-management`} replace />}/>
                <Route path={`/solutions/manajemen-kinerja-perusahaan`} exact element={<PAGE_388/>}/>
                <Route path={`/solutions/manajemen-keuangan`} exact element={<PAGE_382/>}/>
                <Route path={`/solutions/manajemen-biaya`} exact element={<PAGE_391/>}/>
                <Route path={`/solutions/manajemen-aset-perusahaan`} exact element={<PAGE_390/>}/>
                <Route path={`/solutions/financial-management`} exact element={<PAGE_382/>}/>
                <Route path={`/solutions/expense-management`} exact element={<PAGE_391/>}/>
                <Route path={`/solutions/enterprise-performance-management`} exact element={<PAGE_388/>}/>
                <Route path={`/solutions/enterprise-asset-management`} exact element={<PAGE_390/>}/>
                <Route path={`/services`} exact element={<PAGE_381/>}/>
                <Route path={`/services`} exact element={<PAGE_381/>}/>
                <Route path={`/help`} exact element={<Navigate to={`/help/faq`} replace />}/>
                <Route path={`/help/privacy-policy`} exact element={<PAGE_389/>}/>
                <Route path={`/help/faq`} exact element={<PAGE_385/>}/>
                <Route path={`/help/contact`} exact element={<PAGE_387/>}/>
                <Route path={`/blogs`} exact element={<PAGE_485/>}/>
                <Route path={`/blogs`} exact element={<PAGE_485/>}/>
                <Route path={`/blogs/detail/:param1/:param2`} exact element={<PAGE_486/>}/>
                <Route path={`/blogs/detail/:param1/:param2`} exact element={<PAGE_486/>}/>
                <Route path={`/bantuan`} exact element={<Navigate to={`/help/faq`} replace />}/>
                <Route path={`/bantuan/kontak`} exact element={<PAGE_387/>}/>
                <Route path={`/bantuan/kebijakan-privasi`} exact element={<PAGE_389/>}/>
                <Route path={`/bantuan/faq`} exact element={<PAGE_385/>}/>
                <Route path={`/about`} exact element={<PAGE_380/>}/>
                <Route path={`/about`} exact element={<PAGE_380/>}/>
                <Route path={`/error/:id`} exact element={<PAGE_392/>} />
                <Route path={`/`} exact element={<PAGE_378/>}/>
                <Route path="*" element={<PAGE_392/>} />
            </Routes>
            {footer}
         </>
         );
}
